export enum ConversationRole {
  Assistant = 1,
  User = 2
}
